import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingTextField = ({ label, params, loading }) => {
  return (
    <TextField
      {...params}
      label={label}
      slotProps={{
        input: {
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        },
      }}
    />
  );
};

LoadingTextField.propTypes = {
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  params: PropTypes.shape({
    InputProps: PropTypes.shape({
      endAdornment: PropTypes.element,
    }),
  }).isRequired,
};

export default LoadingTextField;
